import React from 'react';
import Terms from "../../components/terms/terms-component";


const Search = (
  {
    searchChange,
    searchValue,
    primary
  }
) => {
  return (
    <div className="terms_container__search">
      <input
        type="text"
        placeholder="Type to search word"
        value={searchValue}
        onChange={e => searchChange({searchValue: e.target.value, primary: primary})}
      />
    </div>
  )
};



const FullReportPrimaryComponent = (
  {
    primaryEmotions,
    sentimentBreakdown,
    primary,
    searchChange,
    primarySearchValue,
    sentimentSearchValue
  }
) => {
  return (
    <div className="full_report_primary">
      {
        primary ?
          <Search
            searchValue={primarySearchValue}
            searchChange={searchChange}
            primary
          />
          :
          <Search
            searchValue={sentimentSearchValue}
            searchChange={searchChange}
          />
      }
      {
        primary ?
          primaryEmotions.map((p, i) => (
          <Terms
            key={i}
            terms={p.terms}
            title={p.primary}
            primary={true}
            searchChange={searchChange}
            searchValue={p.searchValue}
            index={i}
          />
        ))
          :
          sentimentBreakdown.map((s, i) => (
            <Terms
              key={i}
              terms={s.terms}
              title={s.sentiment}
              primary={false}
              searchChange={searchChange}
              searchValue={s.searchValue}
              index={i}
            />
          ))
      }
    </div>
  )
};


export default FullReportPrimaryComponent;


// WEBPACK FOOTER //
// ./src/modules/full-report-primary-or-sentiment/full-report-primary-or-sentiment-component.js